const config = {
  basename: "",
  defaultPath: "/dashboard",
  fontFamily: "Roboto-Regular",
  borderRadius: 5,
}

export default config
